import styled, { css } from 'styled-components';

export const Content = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: ${theme.v2.font.lineHeight.text};
    margin: 0px;
  `};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-self: flex-end;
`;
